
// Centralized API Configuration
// Always returns the production Render URL to ensure local frontend connects to the deployed backend

// export const getServerURL = () => {
//     return 'https://robridge-express-zl9j.onrender.com';
// };

export const getServerURL = () => {
    return 'https://robridge-express-zl9j.onrender.com';
};

// Return local server URL for development/testing
// export const getServerURL = () => {
//     return 'http://localhost:3001';
// };
